import axios from "axios";
import qs from "qs";
//设置请求超时的时间
// axios.defaults.timeout = 5000;
//设置访问的域名前缀
axios.defaults.baseURL = "";

// // axios.defaults.timeout = 1200000;                        //响应时间
// axios.defaults.headers.post["Content-Type"] =
//   "application/x-www-form-urlencoded;charset=UTF-8"; //配置请求头

// //http request 请求拦截器
axios.interceptors.request.use(
  (config) => {
    // 如果数据是FormData类型，说明是上传文件，跳过处理
    if (config.data instanceof FormData) {
      return config;
    }
    // const token = getCookie('名称');
    config.data = qs.stringify(config.data);
    //设置请求头
    config.headers = {
      "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
    };
    // if(token){
    //   config.params = {'token':token}
    // }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

//http response 响应拦截器
axios.interceptors.response.use(
  (res) => {
    // if (response.data.errCode == 2) {
    //   router.push({
    //     path: "/login",
    //     querry: { redirect: router.currentRoute.fullPath }, //从哪个页面跳转
    //   });
    // }
    //对响应数据做些事
    if (!res.data.success) {
      return Promise.resolve(res);
    }
    return res;
  },
  (error) => {
    return Promise.reject(error);
  }
);

/**
 * 封装get方法
 * @param url
 * @param data
 * @returns {Promise}
 */
export function get(url, params = {}) {
  return new Promise((resolve, reject) => {
    axios
      .get(url, {
        params: params,
      })
      .then((response) => {
        resolve(response);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */
export function post(url, data = {}) {
  return new Promise((resolve, reject) => {
    axios.post(url, data).then(
      (response) => {
        resolve(response);
      },
      (err) => {
        reject(err);
      }
    );
  });
}

/**
 * 封装put请求
 * @param url
 * @param data
 * @returns {Promise}
 */
export function put(url, data = {}) {
  return new Promise((resolve, reject) => {
    axios.put(url, data).then(
      (response) => {
        resolve(response);
      },
      (err) => {
        reject(err);
      }
    );
  });
}
